exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hasPadding {\n  position: relative;\n}\n.send_gift_box {\n  position: absolute;\n  right: 5%;\n  top: 15%;\n  width: 4.71rem;\n  z-index: 999;\n}\n.send_gift_box div {\n  margin-bottom: 0.37rem;\n  padding: 0.19rem 0;\n  width: 100%;\n  text-align: center;\n  font-size: 0.37rem;\n  color: #999999;\n  background: rgba(232, 243, 255, 0.96);\n  border-radius: 1.33rem 0.11rem 0.11rem 1.33rem;\n}\n.send_gift_box div span:nth-of-type(1) {\n  padding-right: 0.16rem;\n  color: #027cfa;\n}\n.send_gift_box div img {\n  width: 0.68rem;\n  height: 0.64rem;\n}\n", ""]);

// exports
